<div class="form-group jbm-array-autocomplete clearfix {{class}}" [ngClass]="{'stacked': labelStacked, 'readonly': !editable}">
    <label *ngIf="labelCaption" for="{{id}}" class="{{labelClass}}" [ngClass]="{'col-form-label': !labelStacked }">
        {{labelCaption}}
        <span *ngIf="!editable">:</span>
        <span *ngIf="editable && required" class="asterix">*</span>
    </label>
    <div class="input-container {{inputClass}}" [ngClass]="{'data-value': !editable }">
        <label *ngIf="!editable" class="col-form-label">{{getDataValue()}}</label>
        <div *ngIf="editable" class="autocomplete-input">
            <input id="{{id}}" type="text" [value]="displayValue"
              [attr.maxlength]="maxlength>0 ? maxlength : null" [attr.tabindex]="tabIndex!==null ? tabIndex : null"
              [attr.placeholder]="placeholder"
              (keydown)="keyDown($event)" (input)="input($event)" (blur)="blur($event)" (change)="change($event)" class="form-control" [ngClass]="{'is-invalid': editable && ngControl.invalid && (ngControl.touched || submitted),
              'form-control-sm': sm }"
              autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false">
            <div [hidden]="filteredOptions.length===0 || !listOpen || !editable" class="options">
                <div *ngFor="let o of filteredOptions; index as index" class="option"
                  [ngClass]="{'active': index===activeOptionIndex}" (mousedown)="selectLookupOption(o, $event)">
                    {{getOptionDisplayValue(o)}}
                </div>
            </div>
        </div>
        <ng-content></ng-content>
    </div>
</div>
